import EventTarget from './EventTarget';

export default class KeyboardInputManager extends EventTarget {

	/** @type {HTMLElement} */
	node;
	touchStartClientX;
	touchStartClientY;

	constructor( node ) {
		super();
		this.node = node;
		// Respond to direction keys
		document.addEventListener('keydown', this.onKeyDown.bind(this));
		// Respond to swipe events
		this.node.addEventListener('touchstart', this.onTouchStart.bind(this));
		this.node.addEventListener('touchmove', this.onTouchMove.bind(this));
		this.node.addEventListener('touchend', this.onTouchEnd.bind(this));
	}

	/** @param {KeyboardEvent} event */
	onKeyDown( event ) {
		let map = {
			38: 0, // Up
			39: 1, // Right
			40: 2, // Down
			37: 3, // Left
			75: 0, // Vim up
			76: 1, // Vim right
			74: 2, // Vim down
			72: 3, // Vim left
			87: 0, // W
			68: 1, // D
			83: 2, // S
			65: 3  // A
		};
		let modifiers = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
		let mapped = map[event.which];
		if( !modifiers ) {
			if( mapped !== undefined ) {
				event.preventDefault();
				this.dispatchEvent('move', mapped);
			}
		}
		// R key restarts the game
		if( !modifiers && event.which === 82 ) {
			this.restart.call(this, event);
		}
	}

	/** @param {TouchEvent} event */
	onTouchStart( event ) {
		if( event.touches.length > 1 ) {
			return; // Ignore if touching with more than 1 finger
		}
		this.touchStartClientX = event.touches[0].clientX;
		this.touchStartClientY = event.touches[0].clientY;
		event.preventDefault();
	}

	/** @param {TouchEvent} event */
	onTouchMove( event ) {
		event.preventDefault();
	}

	/** @param {TouchEvent} event */
	onTouchEnd( event ) {
		if( event.touches.length > 0 ) {
			return; // Ignore if still touching with one or more fingers
		}

		let touchEndClientX, touchEndClientY;

		touchEndClientX = event.changedTouches[0].clientX;
		touchEndClientY = event.changedTouches[0].clientY;

		let dx = touchEndClientX - this.touchStartClientX;
		let absDx = Math.abs(dx);

		let dy = touchEndClientY - this.touchStartClientY;
		let absDy = Math.abs(dy);

		if( Math.max(absDx, absDy) > 10 ) {
			// (right : left) : (down : up)
			this.dispatchEvent('move', absDx > absDy ? (dx > 0 ? 1 : 3) : (dy > 0 ? 2 : 0));
		}
	}

}
